var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.38,34.67l2.46-9.18c-1.39-2.51-2.13-5.33-2.13-8.19c0-9.35,7.61-16.96,16.96-16.96 c9.35,0,16.96,7.61,16.96,16.96c0,9.35-7.61,16.96-16.96,16.96c-2.81,0-5.58-0.71-8.06-2.05L0.38,34.67z M10.07,28.75l0.58,0.35 c2.13,1.27,4.56,1.94,7.02,1.94c7.58,0,13.75-6.17,13.75-13.75c0-7.58-6.17-13.75-13.75-13.75c-7.58,0-13.75,6.17-13.75,13.75 c0,2.5,0.7,4.97,2.01,7.13l0.36,0.59l-1.37,5.13L10.07,28.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.98,19.65c-0.7-0.42-1.61-0.88-2.43-0.55c-0.63,0.26-1.03,1.25-1.44,1.75c-0.21,0.26-0.46,0.3-0.78,0.17 c-2.37-0.94-4.18-2.52-5.49-4.7c-0.22-0.34-0.18-0.61,0.08-0.92c0.39-0.46,0.89-0.99,1-1.62c0.11-0.63-0.19-1.36-0.45-1.92 c-0.33-0.71-0.7-1.73-1.41-2.13c-0.66-0.37-1.52-0.16-2.11,0.31c-1.01,0.82-1.5,2.11-1.48,3.39c0,0.36,0.05,0.72,0.13,1.07 c0.2,0.84,0.59,1.63,1.03,2.38c0.33,0.56,0.69,1.11,1.08,1.64c1.27,1.72,2.84,3.22,4.67,4.33c0.91,0.56,1.89,1.05,2.91,1.38 c1.14,0.38,2.16,0.77,3.39,0.54c1.29-0.24,2.56-1.04,3.07-2.29c0.15-0.37,0.23-0.78,0.14-1.17C25.71,20.52,24.63,20.04,23.98,19.65 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.f1ef9a894331f5ef7be5b28e596d1b67.svg";
export { ForwardRef as ReactComponent };